import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import classes from './refilesTable.module.scss';
import { ReactComponent as PrintIcon } from '../../../../assets/icons/print.svg';
import Pagination from '../../../_common/Pagination/Pagination';
import Loader from '../../../_common/Loader/Loader';
import FaxModal from '../FaxModal/FaxModal';
import DOBPicker from '../../../_common/Form/DatePickers/DOBPicker/DOBPicker';
import { updateScriptRequest } from '../../../../store/actions/script';
import accountHelpers from '../../../../utils/accountHelpers';
import { changeRefileData } from '../../../../store/actions/refills';

const RefilesTable = ({
  data, header, className, page, limit, totalPage, onChange, classFax, status,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState({});
  const [changeData, setChangeData] = useState({ id: '', value: '' });

  const trClass = [classes.tr];
  const tdClass = [classes.td];
  const tdDivClass = [classes.td_div];

  const onChangeLoading = async (path, count) => {
    setLoading(true);
    await onChange(path, count);
    setLoading(false);
  };

  if (className) trClass.push(className);
  if (classFax) tdClass.push(classFax);
  if (status === 'Refill') tdDivClass.push(classes.td_div_refill);

  const sendUpdateData = async (id, value) => {
    const currentScript = data?.find((f) => f.id === id);

    if (id && moment(currentScript.processedOn).toString() !== moment(value).toString()) {
      const updateData = await dispatch(updateScriptRequest({
        id: currentScript.id,
        patientId: currentScript.Patient.id,
        physicianId: currentScript.Physician.id,
        processedOn: currentScript.processedOn,
        productId: currentScript.Product.id,
        userId: accountHelpers.getUser().id,
      }));

      if (updateData.status === 'ok') toast.success('Saved new Processed on date');
    }
  };

  const closeElement = (e) => {
    if (!e.target.closest('[id="body"]') && !e.target.closest('[id^="dob-portal"]')
        && !e.target.closest('[id^="dob-container"]') && changeData.id) {
      sendUpdateData(changeData.id, changeData.value);

      setTimeout(() => {
        setChangeData({
          id: '',
          value: '',
        });
      });
    }
  };

  useEffect(() => {
    window.addEventListener('click', closeElement);

    return () => {
      window.removeEventListener('click', closeElement);
    };
  }, [changeData, data]);

  const onFaxClick = (e, physicianId, scriptId, patientId) => {
    e.stopPropagation();
    setModalData({ physicianId, scriptId, patientId });
  };

  const onChangeUpdateData = (value) => {
    if (value.length !== 10) {
      return;
    }

    dispatch(changeRefileData({ ...changeData, value }));
  };

  const processedOnClick = (e, id, value) => {
    e.stopPropagation();

    setChangeData({ id, value });

    if (changeData.id && (changeData.id !== id)) {
      sendUpdateData(changeData.id, changeData.value);
    }
  };

  const closeFaxModal = () => {
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('width');
    document.body.ontouchmove = () => true;

    setModalData({});
  };

  return (
    <div>
      {(!loading && !data.length)

        ? <div className={classes.notResult}>No Data Found</div>
        : (
          <>
            <div className={classes.table_wrapper}>
              {loading && <Loader />}
              <div className={classes.table__border}>
                <table className={classes.table}>

                  <thead className={classes.thead}>
                    <tr className={classes.tr}>
                      {header.map((h) => (
                        h === 'Fax' || h === 'Last Faxed'
                          ? status === 'Renew' && <th className={classes.th} key={h}>{h}</th>
                          : <th className={classes.th} key={h}><div className={classes.td_div}>{h}</div></th>
                      ))}
                    </tr>
                  </thead>

                  <tbody id="body" className={classes.tbody}>
                    {data.map((d) => (
                      <tr className={trClass.join(' ')} key={d.id}>
                        <td
                          className={classes.td}
                        >
                          {(changeData.id === d.id)
                            ? (
                              <DOBPicker
                                hideClearButton
                                date={d.processedOn}
                                wrapperClassName={classes.calendar_wrapper}
                                dateFormat="YYYY-MM-DD"
                                onChange={(date) => onChangeUpdateData(date)}
                              />
                            )
                            : d.processedOn
                              ? (
                                <div
                                  className={classes.processed}
                                  onClick={(e) => processedOnClick(e, d.id, d.processedOn)}
                                >
                                  {moment(d.processedOn).format('MM/DD/YYYY')}
                                </div>
                              )
                              : '-'}
                        </td>

                        <td onClick={() => navigate(`/scripts/${d.id}`)} className={classes.td}>
                          <div className={tdDivClass.join(' ')}>
                            {`${d.Physician.firstName} ${d.Physician.lastName}`}
                          </div>
                        </td>

                        <td onClick={() => navigate(`/scripts/${d.id}`)} className={classes.td}>
                          <div className={tdDivClass.join(' ')}>
                            {`${d.Patient.firstName} ${d.Patient.lastName}`}
                          </div>
                        </td>

                        <td onClick={() => navigate(`/scripts/${d.id}`)} className={classes.td}>
                          <div className={tdDivClass.join(' ')}>
                            {d.Product.name}
                          </div>
                        </td>

                        <td onClick={() => navigate(`/scripts/${d.id}`)} className={classes.td}>
                          <div className={tdDivClass.join(' ')}>
                            {d.rxNumber}
                          </div>
                        </td>

                        {/* <td className={classes.td}> */}
                        {/*  {moment(d.dob).format('MM/DD/YYYY')} */}
                        {/* </td> */}

                        {status === 'Renew' && (
                        <>
                          <td onClick={() => navigate(`/scripts/${d.id}`)} className={classes.td}>
                            <div className={classes.td_div}>
                              <p>{d.lastFaxed ? moment(d.lastFaxed).format('MM/DD/YYYY') : '-'}</p>
                              <p>{d?.manual !== null ? (d?.manual ? 'Manually' : 'Electronically') : '-'}</p>
                            </div>
                          </td>

                          <td className={tdClass.join(' ')}>
                            <div>
                              <p>{d.faxNum}</p>
                              <PrintIcon
                                onClick={(e) => onFaxClick(e, d.Physician.id, d.id, d.Patient.id)}
                              />
                            </div>
                          </td>
                        </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <Pagination page={page} limit={limit} totalPage={totalPage} onChange={onChangeLoading} />
          </>
        )}

      {!_.isEmpty(modalData) && (
      <FaxModal
        modalData={modalData}
        onClose={closeFaxModal}
        status={status}
      />
      )}
    </div>
  );
};

RefilesTable.propTypes = {
  header: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  totalPage: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  classFax: PropTypes.string,
  status: PropTypes.string.isRequired,
};

RefilesTable.defaultProps = {
  className: '',
  classFax: '',
};

export default RefilesTable;
